import {
  addDays,
  addWeeks,
  format,
  isToday,
  isTomorrow,
  parse,
  startOfWeek
} from 'date-fns';
import { TFunction } from 'react-i18next';

import {
  DayWiseSlotHoldDatesDetailInterface,
  DDMMYYYY_DATE_FORMAT,
  WEBINAR_SLOTS_DATE_DISPLAY_FORMAT,
  WEEK_DAYS_COUNT
} from '@nw/shared/config';

import { TODAY, TOMORROW } from '../../constants/TimeLapsedConstants';

export const getTodayDate = (): Date => {
  return new Date();
};

export const getLabelText = (date: Date): string => {
  switch (true) {
    case isToday(date):
      return TODAY;
    case isTomorrow(date):
      return TOMORROW;
    default:
      return format(date, WEBINAR_SLOTS_DATE_DISPLAY_FORMAT);
  }
};

export const formatDatesStringToNewDateFormat = (
  datesArray: Array<string> | Array<DayWiseSlotHoldDatesDetailInterface>,
  dateFormat: string = DDMMYYYY_DATE_FORMAT
) => {
  const formattedDatesArray: Array<string> = [];
  datesArray.forEach((eachDate) => {
    const date = eachDate.date ?? eachDate;

    const dateToFormat = parse(date, dateFormat, new Date());
    formattedDatesArray.push(String(dateToFormat));
  });
  return formattedDatesArray;
};

export const getDateFromDayCode = (dayCode: number) => {
  const currentDate = new Date();
  const currentDay = currentDate.getDay();
  let dayDifference = dayCode - currentDay;
  if (dayCode === WEEK_DAYS_COUNT.SUNDAY && currentDay !== 0) {
    dayDifference = (dayCode + 7 - currentDay) % 7;
  }
  currentDate.setDate(currentDate.getDate() + dayDifference);
  currentDate.setHours(0, 0, 0, 0);
  return currentDate;
};

export const getDayNameByDayCount = (dayCode: number, t: TFunction) => {
  const tPrefix = `publicRegistrationForm.IITWebinarRegistrationFormTelugu.`;
  switch (dayCode) {
    case WEEK_DAYS_COUNT.MONDAY:
      return t(`${tPrefix}monday`);
    case WEEK_DAYS_COUNT.TUESDAY:
      return t(`${tPrefix}tuesday`);
    case WEEK_DAYS_COUNT.WEDNESDAY:
      return t(`${tPrefix}wednesday`);
    case WEEK_DAYS_COUNT.THURSDAY:
      return t(`${tPrefix}thursday`);
    case WEEK_DAYS_COUNT.FRIDAY:
      return t(`${tPrefix}friday`);
    case WEEK_DAYS_COUNT.SATURDAY:
      return t(`${tPrefix}saturday`);
    default:
      return t(`${tPrefix}sunday`);
  }
};

export const getNextDatesForDayCodes = (dayCodes: Array<number>) => {
  const currentDate = new Date();
  const currentDateWeekDay = currentDate.getDay();
  const nextDates: Array<string> = [];
  dayCodes.forEach((dayCode) => {
    let startOfNextWeek;
    if (currentDateWeekDay === 0 && dayCode !== 0) {
      startOfNextWeek = startOfWeek(currentDate);
    } else {
      startOfNextWeek = startOfWeek(addWeeks(currentDate, 1));
    }
    let targetDate = addDays(startOfNextWeek, dayCode);
    if (targetDate < currentDate) {
      targetDate = addWeeks(targetDate, 1);
    }
    nextDates.push(format(targetDate, DDMMYYYY_DATE_FORMAT));
  });

  return nextDates;
};

export const getNextNDates = (n = 10): Array<Date> => {
  const nextDates: Array<Date> = [];

  for (let i = 0; i < n; i++) {
    const nextDate = new Date(new Date().setDate(new Date().getDate() + i));
    nextDate.setHours(0, 0, 0, 0);
    nextDates.push(nextDate);
  }
  return nextDates;
};
